import { render, staticRenderFns } from "./NewManagedLandownerForm.vue?vue&type=template&id=3b49b776"
import script from "./NewManagedLandownerForm.vue?vue&type=script&lang=js"
export * from "./NewManagedLandownerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports